import { requestJSON } from "./http";

const decorateSearchParameters = (filter) =>
  filter ? { __type: "Fund", ...filter } : { __type: "Fund" };

const create = (fund, accessToken) =>
  requestJSON({
    path: "/funds",
    method: "POST",
    data: fund,
    accessToken,
  });

// with pagination
const search = (searchParams, abortController, accessToken) =>
  requestJSON({
    path: "/funds/search",
    method: "POST",
    data: decorateSearchParameters(searchParams),
    abortController,
    accessToken,
  });

const getById = (id, accessToken) =>
  requestJSON({
    path: `/funds/${id}`,
    accessToken,
  });

const patch = (id, changes, description, accessToken) =>
  requestJSON({
    path: `/funds/${id}`,
    method: "PATCH",
    data: {
      fields: Object.keys(changes),
      changes,
      description,
    },
    accessToken,
  });

const checkFriendlyIdAvailability = (id, friendlyId, accessToken) =>
  id
    ? requestJSON({
        path: `/funds/${id}/friendly-available/${friendlyId}`,
        accessToken,
      })
    : requestJSON({
        path: `/funds/friendly-available/${friendlyId}`,
        accessToken,
      });

export default {
  create,
  search,
  getById,
  patch,
  checkFriendlyIdAvailability,
};
